module.exports = __webpack_public_path__ + "img/Refreshing Mint & Menthol.44a30e22.jpg";